import React from 'react'

import { Background, Highlight, Copyright } from './styles'

function Footer (){
  return (
    <Background>
      <Highlight>
        <Copyright>
          <p>© 2019 Mateus Vinícius | This site is a fan project | All rights reserved.</p>
        </Copyright>  
      </Highlight>
    </Background>
  )
}

export default Footer